import React from 'react';
import MyNotifications from '../views/App/notifications/notification/MyNotifications';
import AppNotifications from '../views/App/notifications/Notifications';

export const notificationTabs = () => [
  {
    id: 'my-notifications',
    label: 'Mis Notificaciones',
    path: 'my-notifications',
    component: <MyNotifications />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
];

const notificationsRoutes = () => [
  {
    id: 'notifications',
    label: 'Notificaciones',
    path: '/app/notifications',
    component: <AppNotifications />,
    disabled: false,
    show: false,
    showInNavbar: false,
    subRoutes: [],
  },
];

export default notificationsRoutes;
